export default __webpack_public_path__ + "static/media/profileSidebarIcon_admin.ddc2539d.svg";